<div class="skeleton-shop-tile-compact-image"></div>
<div class="skeleton-shop-tile-compact-details">
  <div class="skeleton-shop-tile-compact-info">
    <div class="skeleton-shop-tile-compact-name skeleton-shop-tile-compact-row"></div>
    <div class="skeleton-shop-tile-compact-row skeleton-shop-tile-compact-row-1"></div>
    <div class="skeleton-shop-tile-compact-row skeleton-shop-tile-compact-row-2"></div>
    <div class="skeleton-shop-tile-compact-row skeleton-shop-tile-compact-row-3"></div>
  </div>
</div>
